import { Popover, Transition } from "@headlessui/react";
import {
  UserCircleIcon,
  ChatBubbleBottomCenterTextIcon,
  HeartIcon,
  HomeIcon,
  ArrowRightOnRectangleIcon,
  LifebuoyIcon,
} from "@heroicons/react/24/outline";
import { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";
import useFetch from "hooks/useFetch";
import config from "config.json"

const solutions = [
  {
    name: "Mi cuenta",
    href: "/account",
    icon: UserCircleIcon,
  },
  /* {
    name: "Messages",
    href: "##",
    icon: ChatBubbleBottomCenterTextIcon,
  },
  {
    name: "Wishlists",
    href: "/account-savelists",
    icon: HeartIcon,
  }, */
  {
    name: "Mis reservas",
    href: "##",
    icon: HomeIcon,
  },
];

const solutionsFoot = [
  /* {
    name: "Help",
    href: "##",
    icon: LifebuoyIcon,
  }, */

  {
    name: "Cerrar sesión",
    href: "##",
    icon: ArrowRightOnRectangleIcon,
  },
];

export default function AvatarDropdown() {

  const url = config.backend_url;

  const user_token = sessionStorage.getItem("user_token");

  const {data, error, isLoading, fetchData} = useFetch(
    'PUT',
    `${url}/authe/logout`,
    {},
    {'SetiaAuthorization': `${user_token}` }
  );



  const handleUserLogout = (e: React.FormEvent) => {
    e.preventDefault();
    fetchData()
  }

  useEffect(() => {
    if (data) {
      const response = data as any
      switch (response.code) {
        case '200':
          sessionStorage.clear()
          sessionStorage.removeItem('user_token')
          sessionStorage.removeItem('user_login')
          window.location.href = '/'
          break
        default:
          sessionStorage.clear()
          window.location.href = '/'
          break
      }
    }

    if (error) {
      sessionStorage.clear()
      window.location.href = '/'
    }
  }, [data, error])
  
  return (
    <div className="hidden lg:flex xl:flex AvatarDropdown">
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button
              className={`inline-flex items-center focus:outline-none`}
            >
              <Avatar sizeClass="w-8 h-8 sm:w-9 sm:h-9" />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-[260px] px-4 mt-4 -right-10 sm:right-0 sm:px-0">
                <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="relative grid gap-6 bg-white dark:bg-neutral-800 p-7">
        
                      <Link
                        to='/account'
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                      >
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          <UserCircleIcon aria-hidden="true" className="w-6 h-6" />
                        </div>
                        <div className="ml-4">
                          <p className="text-sm font-medium ">Mi cuenta</p>
                        </div>
                      </Link>
                      <Link
                      to='/account-savelists'
                      className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                    >
                      <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                        <HomeIcon aria-hidden="true" className="w-6 h-6" />
                      </div>
                      <div className="ml-4">
                        <p className="text-sm font-medium ">Mis reservas</p>
                      </div>
                    </Link>

                  </div>
                  <hr className="h-[1px] border-t border-neutral-300 dark:border-neutral-700" />
                  <div className="relative grid gap-6 bg-white dark:bg-neutral-800 p-7">
                      <a
                        href="/"
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        onClick={handleUserLogout}
                      >
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          <ArrowRightOnRectangleIcon aria-hidden="true" className="w-6 h-6 text-red-400" />
                        </div>
                        <div className="ml-4">
                          <p className="text-sm font-medium text-red-400">Cerrar sesión</p>
                        </div>
                      </a>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}
